"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFormatNumber = void 0;
const app_platform_common_1 = require("@semios/app-platform-common");
const makeFormatNumber = (tTemplates) => {
    return (value, options) => {
        if ((0, app_platform_common_1.isNil)(value))
            return tTemplates('-');
        return tTemplates('{{value, number}}', {
            value,
            formatParams: {
                value: {
                    maximumFractionDigits: 20, // We don't want default. See here: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#maximumfractiondigits
                    ...options,
                },
            },
        });
    };
};
exports.makeFormatNumber = makeFormatNumber;
//# sourceMappingURL=makeFormatNumber.js.map